import React, { useEffect } from 'react';
import { Field, Radio } from 'ui';
import useAddress from '~/hooks/useAddress';
import {
  changedShipsFromCountry,
  getListFlowShipsFromCountry,
} from '~/store/listFlow/slices/shipping';
import { useAppDispatch, useAppSelector } from '~/store/store';

interface Props {}

const ShipsFromCountryPicker: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const { data: shipsFromAddress } = useAddress('shipFrom');
  const country = useAppSelector(getListFlowShipsFromCountry);

  useEffect(() => {
    if (shipsFromAddress?.country && country !== shipsFromAddress.country) {
      dispatch(changedShipsFromCountry(shipsFromAddress?.country));
    }
  }, [country, dispatch, shipsFromAddress?.country]);

  if (shipsFromAddress?.country) {
    return null;
  }

  return (
    <div>
      <Field label="Where are you shipping from?">
        <div className="flex space-x-4">
          <label className="flex items-center space-x-2">
            <Radio
              checked={country === 'US'}
              value="US"
              onChange={() => dispatch(changedShipsFromCountry('US'))}
            />
            <span>United States</span>
          </label>
          <label className="flex items-center space-x-2">
            <Radio
              checked={country === 'CA'}
              value="CA"
              onChange={() => dispatch(changedShipsFromCountry('CA'))}
            />
            <span>Canada</span>
          </label>
        </div>
      </Field>
    </div>
  );
};

export default ShipsFromCountryPicker;
